export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.8687 1.03125H2.13125C1.52374 1.03125 1.03125 1.52374 1.03125 2.13125V19.8687C1.03125 20.4763 1.52374 20.9688 2.13125 20.9688H11.6875V13.2584H9.09219V10.2403H11.6875V8.01969C11.6875 5.445 13.2619 4.0425 15.5581 4.0425C16.3319 4.04081 17.1053 4.07982 17.875 4.15938V6.85094H16.2938C15.0425 6.85094 14.7984 7.44219 14.7984 8.31531V10.2369H17.7891L17.4006 13.255H14.7812V20.9688H19.8687C20.4763 20.9688 20.9688 20.4763 20.9688 19.8687V2.13125C20.9688 1.52374 20.4763 1.03125 19.8687 1.03125Z"
        fill="black"
      />
    </svg>
  );
};


export const InstragramIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0185 1.58674C11.5646 1.5162 12.0582 1.49951 15.995 1.49951C19.9317 1.49951 20.4253 1.5162 21.9714 1.58674C23.5143 1.65711 24.568 1.90217 25.49 2.26053C26.4432 2.63091 27.2516 3.12656 28.0575 3.9324C28.8633 4.73831 29.359 5.54668 29.7294 6.49988C30.0877 7.4219 30.3328 8.47562 30.4031 10.0185C30.4737 11.5646 30.4904 12.0582 30.4904 15.995C30.4904 19.9317 30.4737 20.4253 30.4031 21.9714C30.3328 23.5143 30.0877 24.568 29.7294 25.49C29.359 26.4432 28.8633 27.2516 28.0575 28.0575C27.2516 28.8633 26.4432 29.359 25.49 29.7294C24.568 30.0877 23.5143 30.3328 21.9714 30.4031C20.4253 30.4737 19.9317 30.4904 15.995 30.4904C12.0582 30.4904 11.5646 30.4737 10.0185 30.4031C8.47562 30.3328 7.4219 30.0877 6.49988 29.7294C5.54668 29.359 4.73831 28.8633 3.9324 28.0575C3.12656 27.2516 2.63091 26.4432 2.26053 25.49C1.90217 24.568 1.65711 23.5143 1.58674 21.9714C1.5162 20.4253 1.49951 19.9317 1.49951 15.995C1.49951 12.0582 1.5162 11.5646 1.58674 10.0185C1.65711 8.47562 1.90217 7.4219 2.26053 6.49988C2.63091 5.54668 3.12656 4.73831 3.9324 3.9324C4.73831 3.12656 5.54668 2.63091 6.49988 2.26053C7.4219 1.90217 8.47562 1.65711 10.0185 1.58674ZM24.5439 4.69492C24.0331 4.49641 23.2656 4.26027 21.8523 4.19582C20.3238 4.12608 19.8654 4.1113 15.995 4.1113C12.1245 4.1113 11.666 4.12608 10.1375 4.19582C8.72425 4.26027 7.95673 4.49641 7.44595 4.69492C6.76934 4.95788 6.28647 5.27199 5.77926 5.77926C5.27199 6.28647 4.95788 6.76934 4.69492 7.44595C4.49641 7.95673 4.26027 8.72425 4.19582 10.1375C4.12608 11.666 4.1113 12.1245 4.1113 15.995C4.1113 19.8654 4.12608 20.3238 4.19582 21.8523C4.26027 23.2656 4.49641 24.0331 4.69492 24.5439C4.95788 25.2205 5.27204 25.7034 5.77926 26.2106C6.28647 26.7179 6.76934 27.032 7.44595 27.295C7.95673 27.4935 8.72425 27.7296 10.1375 27.7941C11.6659 27.8638 12.1242 27.8786 15.995 27.8786C19.8657 27.8786 20.3241 27.8638 21.8523 27.7941C23.2656 27.7296 24.0331 27.4935 24.5439 27.295C25.2205 27.032 25.7034 26.7179 26.2106 26.2106C26.7179 25.7034 27.032 25.2205 27.295 24.5439C27.4935 24.0331 27.7296 23.2656 27.7941 21.8523C27.8638 20.3238 27.8786 19.8654 27.8786 15.995C27.8786 12.1245 27.8638 11.666 27.7941 10.1375C27.7296 8.72425 27.4935 7.95673 27.295 7.44595C27.032 6.76934 26.7179 6.28647 26.2106 5.77926C25.7034 5.27199 25.2205 4.95788 24.5439 4.69492ZM15.995 8.55134C11.8839 8.55134 8.55134 11.8839 8.55134 15.995C8.55134 20.1059 11.8839 23.4385 15.995 23.4385C20.1059 23.4385 23.4385 20.1059 23.4385 15.995C23.4385 11.8839 20.1059 8.55134 15.995 8.55134ZM11.1631 15.995C11.1631 18.6635 13.3264 20.8267 15.995 20.8267C18.6635 20.8267 20.8267 18.6635 20.8267 15.995C20.8267 13.3264 18.6635 11.1631 15.995 11.1631C13.3264 11.1631 11.1631 13.3264 11.1631 15.995ZM23.7326 9.99668C24.6933 9.99668 25.4721 9.21794 25.4721 8.25726C25.4721 7.29658 24.6933 6.51778 23.7326 6.51778C22.772 6.51778 21.9932 7.29658 21.9932 8.25726C21.9932 9.21794 22.772 9.99668 23.7326 9.99668Z"
        fill="black"
      />
    </svg>
  );
};


export const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="25px"
      height="25px"
    >
      <path d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z" />
    </svg>
  );
};


export const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25px"
      height="25px"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.2126 26.2112H21.9123V19.48C21.9123 17.8753 21.8833 15.8115 19.676 15.8115C17.4396 15.8115 17.098 17.5612 17.098 19.3656V26.2112H12.801V12.3718H16.9224V14.2632H16.982C17.5572 13.1757 18.959 12.0286 21.0519 12.0286C25.4086 12.0286 26.2126 14.8932 26.2126 18.6213V26.2112ZM7.95125 10.4819C6.56884 10.4819 5.45389 9.36383 5.45389 7.98633C5.45389 6.61044 6.56884 5.49233 7.95125 5.49233C9.3256 5.49233 10.4438 6.61044 10.4438 7.98633C10.4438 9.36383 9.3256 10.4819 7.95125 10.4819ZM5.79546 26.2112H10.1022V12.3718H5.79546V26.2112ZM28.3539 1.5H3.63806C2.45866 1.5 1.5 2.43606 1.5 3.59122V28.4072C1.5 29.5623 2.45866 30.5 3.63806 30.5H28.3539C29.5365 30.5 30.5 29.5623 30.5 28.4072V3.59122C30.5 2.43606 29.5365 1.5 28.3539 1.5Z"
        fill="black"
      />
    </svg>
  );
};


export const YoutubeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31 9.92016C31 7.38702 28.9465 5.3335 26.4133 5.3335H5.58667C3.05352 5.3335 1 7.38702 1 9.92016V22.0802C1 23.2966 1.48324 24.4633 2.3434 25.3234C3.20357 26.1836 4.37021 26.6668 5.58667 26.6668H26.4133C28.9465 26.6668 31 24.6133 31 22.0802V9.92016ZM12.6667 21.2535V9.70683L21.6933 15.4802L12.6667 21.2535Z"
        fill="black"
      />
      <path
        d="M5.58667 5.3335V6.0835V5.3335ZM12.6667 21.2535H11.9167C11.9167 21.5275 12.0661 21.7798 12.3065 21.9114C12.5469 22.043 12.8399 22.033 13.0708 21.8853L12.6667 21.2535ZM12.6667 9.70683L13.0708 9.07501C12.8399 8.92735 12.5469 8.91736 12.3065 9.04896C12.0661 9.18056 11.9167 9.43278 11.9167 9.70683H12.6667ZM21.6933 15.4802L22.0974 16.112C22.3129 15.9741 22.4433 15.736 22.4433 15.4802C22.4433 15.2243 22.3129 14.9862 22.0974 14.8483L21.6933 15.4802ZM31.75 9.92016C31.75 6.9728 29.3607 4.5835 26.4133 4.5835V6.0835C28.5323 6.0835 30.25 7.80123 30.25 9.92016H31.75ZM26.4133 4.5835H5.58667V6.0835H26.4133V4.5835ZM5.58667 4.5835C2.63931 4.5835 0.25 6.9728 0.25 9.92016H1.75C1.75 7.80123 3.46773 6.0835 5.58667 6.0835V4.5835ZM0.25 9.92016V22.0802H1.75V9.92016H0.25ZM0.25 22.0802C0.25 23.4955 0.812254 24.8529 1.81307 25.8538L2.87373 24.7931C2.15422 24.0736 1.75 23.0977 1.75 22.0802H0.25ZM1.81307 25.8538C2.81389 26.8546 4.17129 27.4168 5.58667 27.4168V25.9168C4.56912 25.9168 3.59325 25.5126 2.87373 24.7931L1.81307 25.8538ZM5.58667 27.4168H26.4133V25.9168H5.58667V27.4168ZM26.4133 27.4168C29.3607 27.4168 31.75 25.0275 31.75 22.0802H30.25C30.25 24.1991 28.5323 25.9168 26.4133 25.9168V27.4168ZM31.75 22.0802V9.92016H30.25V22.0802H31.75ZM13.4167 21.2535V9.70683H11.9167V21.2535H13.4167ZM12.2626 10.3387L21.2892 16.112L22.0974 14.8483L13.0708 9.07501L12.2626 10.3387ZM21.2892 14.8483L12.2626 20.6217L13.0708 21.8853L22.0974 16.112L21.2892 14.8483Z"
        fill="black"
      />
    </svg>
  );
};


export const RSSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200q0-33 23.5-56.5T200-280q33 0 56.5 23.5T280-200q0 33-23.5 56.5T200-120Zm480 0q0-117-44-218.5T516-516q-76-76-177.5-120T120-680v-120q142 0 265 53t216 146q93 93 146 216t53 265H680Zm-240 0q0-67-25-124.5T346-346q-44-44-101.5-69T120-440v-120q92 0 171.5 34.5T431-431q60 60 94.5 139.5T560-120H440Z" />
    </svg>
  );
};
